import { combineEpics } from 'redux-observable';

import { _reducer } from './assessementChecklist.reducers';
import _epics from './assessementChecklist.epics';

export const epics = combineEpics(_epics);
export { _reducer };
export * from './assessementChecklist.actions';
